import Vue from 'vue'
import VueI18n from 'vue-i18n'

import dateTimeFormats from '@/plugins/i18n/dateTimeFormats'
import messages from '@/plugins/i18n/messages'
import numberFormats from '@/plugins/i18n/numberFormats'

Vue.use(VueI18n)

const AVAILABLE_LOCALS = ['en', 'fr', 'pt']

const locales = navigator.languages
let locale = 'fr'

if (locales && locales.length > 0) {
	for (let i = 0; i < locales.length; i++) {
		let loc = locales[i]
		if (loc.includes('-')) {
			const index = loc.indexOf('-')
			loc = loc.substring(0, index)
		}
		if (AVAILABLE_LOCALS.includes(loc)) {
			locale = loc
			break
		}
	}
}

export const i18n = new VueI18n({
	fallbackLocale: 'fr',
	locale: locale,
	messages: messages,
	dateTimeFormats: dateTimeFormats,
	numberFormats: numberFormats,
	silentTranslationWarn: true
})

if (module.hot) {
	module.hot.accept(
		['@/plugins/i18n/dateTimeFormats', '@/plugins/i18n/messages', '@/plugins/i18n/numberFormats'],
		() => {
			const updatedDateTimeFormats = require('@/plugins/i18n/dateTimeFormats').default
			const updatedMessages = require('@/plugins/i18n/messages').default
			const updatedNumberFormats = require('@/plugins/i18n/numberFormats').default

			Object.entries(updatedDateTimeFormats).forEach(([updatedLocale, formats]) => {
				i18n.setDateTimeFormat(updatedLocale, formats)
			})
			Object.entries(updatedMessages).forEach(([updatedLocale, localeMessages]) => {
				i18n.setLocaleMessage(updatedLocale, localeMessages)
			})
			Object.entries(updatedNumberFormats).forEach(([updatedLocale, formats]) => {
				i18n.setNumberFormat(updatedLocale, formats)
			})
		}
	)
}
